export default __webpack_public_path__ + "static/media/vase-new-crop.ae11b56f.jpg";